import React from 'react';

export const DefaultLayout = ({ children }: { children: React.ReactNode }) => <>{children}</>;

export default DefaultLayout;
